import React, { useState } from "react";
import "./pages.css";
import { useRegisterMutation } from "../store/api/authApi";
import { Link, useNavigate } from "react-router-dom";
import Button from "../components/Button";

export function RegisterForm() {
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const navigate = useNavigate();

  const [confirmPassword, setConfirmPassword] = useState("");
  const [errors, setErrors] = React.useState({
    email: "",
    password: "",
    confirmPassword: "",
    phone: ""
  });
  const [showPassword, setShowPassword] = React.useState(false);

  const [errorMessage, setErrorMessage] = useState(""); // 🔥 новый стейт ошибки

  const [register, { isLoading }] = useRegisterMutation();

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage(""); // очистка ошибки перед запросом

    if (
      errors.email ||
      errors.password ||
      errors.confirmPassword ||
      errors.phone ||
      !email ||
      !password ||
      !confirmPassword
    ) {
      setErrorMessage("Проверьте правильность заполнения полей.");
      return;
    }

    try {
      const response = await register({ email, phone, password }).unwrap();

      // 🔥 Обработка ошибок от бэка
      switch (response.result) {
        case -1:
          setErrorMessage("Неверно заполнены данные. Проверьте email и пароль.");
          return;

        case -2:
          setErrorMessage(""); // прячем ошибку
          alert("Аккаунт уже существует. Нажмите OK, чтобы восстановить пароль.");
          navigate("/confirm-code", { state: { email } });
          return;

        case -3:
          setErrorMessage("Ошибка сервера. Попробуйте позже.");
          return;

        case 0:
          setErrorMessage("Не удалось зарегистрироваться. Попробуйте ещё раз.");
          return;
      }

      // Успех — переходим на ввод кода
      navigate("/confirm-code", {
        state: { email, reg: true, password }
      });
    } catch (err) {
      console.error("Ошибка:", err);

      // 🔥 Ошибка сети, таймаут, CORS, 500 и т.п.
      setErrorMessage("Произошла ошибка при подключении. Проверьте интернет или попробуйте позже.");
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);

    if (!value) {
      setErrors((prev) => ({ ...prev, email: "Email обязателен" }));
    } else if (!/\S+@\S+\.\S+/.test(value)) {
      setErrors((prev) => ({ ...prev, email: "Неправильный формат email" }));
    } else {
      setErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);

    if (!value) {
      setErrors((prev) => ({ ...prev, password: "Пароль обязателен" }));
    } else if (value.length < 2) {
      setErrors((prev) => ({ ...prev, password: "Минимум 2 символов" }));
    } else {
      setErrors((prev) => ({ ...prev, password: "" }));
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    if (value !== password) {
      setErrors((prev) => ({ ...prev, confirmPassword: "Пароли не совпадают" }));
    } else {
      setErrors((prev) => ({ ...prev, confirmPassword: "" }));
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value;
    setPhone(value);

    // Телефон может быть любым — валидация не нужна
    setErrors((prev) => ({ ...prev, phone: "" }));
  };

  return (
    <div className="login">

      {isLoading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}

      <div className="login_form">
        <div className="login-form_top"></div>

        <div className="login-form_title">Авторизация</div>

        <div className="login-form_field">
          <div className="login-form_label">email</div>
          <input
            className="login-form_inp"
            type="email"
            placeholder="Email"
            value={email}
            onChange={handleEmailChange}
            required
          />
          {errors.email && <div className="error-text">{errors.email}</div>}
        </div>

        <br />

        <div className="login-form_field">
          <div className="login-form_label">Номер телефона</div>
          <input
            className="login-form_inp"
            type="tel"
            placeholder="+7XXXXXXXXXX"
            value={phone}
            onChange={handlePhoneChange}
            required
          />
          {errors.phone && <div className="error-text">{errors.phone}</div>}
        </div>

        <br />

        <div className="login-form_field">
          <div className="login-form_label">Пароль</div>
          <input
            className="login-form_inp"
            type={showPassword ? "text" : "password"}
            placeholder="Пароль"
            value={password}
            onChange={handlePasswordChange}
            required
          />
          {errors.password && <div className="error-text">{errors.password}</div>}
        </div>

        <br />

        <div className="login-form_field">
          <div className="login-form_label">Повторите пароль</div>
          <input
            className="login-form_inp"
            type={showPassword ? "text" : "password"}
            placeholder="Пароль"
            value={confirmPassword}
            onChange={handleConfirmPasswordChange}
            required
          />
          {errors.confirmPassword && <div className="error-text">{errors.confirmPassword}</div>}
        </div>

        <br />

        {/* 🔥 Общая ошибка */}
        {errorMessage && (
          <div className="global-error">
            {errorMessage}
          </div>
        )}

        <div className="login-form_bottom">
          <Button onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? "Загрузка..." : "Регистрация"}
          </Button>

          <div className="login-form_bottom_text">
            У вас уже есть аккаунт?{" "}
            <Link to="/login" className="register">Войти</Link>
          </div>
        </div>
      </div>

      <div className="login-img">
        <img src="/new-logo.jpg" alt="" />
      </div>
    </div>
  );
}

export default RegisterForm;
